import * as React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import "../components/layout.css"

const Destinations = () => (
  <Layout>
    <SEO title="destinations" />
    <h1 className="destinations">destinations</h1>
  </Layout>
)

export default Destinations
